import React, { useEffect, useState } from 'react';
import { useScanner } from 'hooks';

import { QRReaderProps } from './QrReader.types';
import { useStyles } from './QRReader.styles';

const videoElementId = 'codeScannerVideo';

export const QRReader = ({
  handleError,
  handleRead,
  styles = {},
  readInterval = 500,
  delayNextScan = false,
}: QRReaderProps) => {
  const { container, readerContainer } = useStyles({ styles });
  const [isDataRead, setIsDataRead] = useState(false);
  const data = useScanner({ videoElementId, readInterval, handleError, delayNextScan });

  useEffect(() => {
    if (data && !isDataRead) {
      handleRead(data);
      setIsDataRead(true);
    }
  }, [data, handleRead, isDataRead]);

  return (
    <div className={container}>
      <div className={readerContainer}>
        <video data-testid="qrvideo" id={videoElementId} />
      </div>
    </div>
  );
};
